import { Injectable } from '@angular/core';
import * as Highcharts from 'highcharts';

@Injectable({
    providedIn: 'root',
})
export class HighchartsService {
    private static initialized = false;

    init(): void {
        if (!HighchartsService.initialized) {
            this.adaptChartToLegend();
            HighchartsService.initialized = true;
        }
    }

    private adaptChartToLegend(): void {
        // https://api.highcharts.com/highcharts/legend.navigation.enabled
        // https://github.com/highcharts/adapt-chart-to-legend

        Highcharts.wrap(Highcharts.Legend.prototype, 'render', function (proceed) {
            const chart = this.chart as Highcharts.Chart;
            let translateY: number;
            let addedHeight: number;

            proceed.call(this);

            if (this.options.adjustChartSize) {
                addedHeight = this.legendHeight;
                if (!(chart as any).originalChartHeight) {
                    (chart as any).originalChartHeight = chart.chartHeight;
                }

                if (this.options.align === 'left' || this.options.align === 'right') {
                    addedHeight = Math.max(this.legendHeight - (chart as any).originalChartHeight, 0);
                } else if (this.options.verticalAlign === 'bottom') {
                    // Move the legend down
                    translateY = -this.group.translateY + this.legendHeight;
                    this.group.attr('translateY', translateY);
                    if (this.group.alignAttr) {
                        this.group.alignAttr.translateY = translateY;
                    }
                }

                if (addedHeight) {
                    // Adapt chart metrics
                    chart.chartHeight = (chart as any).originalChartHeight + addedHeight;

                    if (this.options.verticalAlign === 'middle') {
                        this.group.attr('translateY', 0);
                    }

                    // Set the DOM element heights
                    chart.container.style.height = chart.chartHeight + 'px';
                    chart.renderer.boxWrapper.attr('height', chart.chartHeight);

                    const boxedElement = chart.renderer.box.clientWidth
                        ? chart.renderer.box /*IE*/
                        : chart.renderer.box.parentElement; /*FF*/
                    const viewBox = '0 0 ' + boxedElement.clientWidth + ' ' + boxedElement.clientHeight;
                    chart.renderer.boxWrapper.attr('viewBox', viewBox);
                }
                this.positionCheckboxes();
            }
        });
    }
}
